export const STATUS_CREATED = "CREATED";
export const STATUS_CANCEL = "CANCEL";
export const STATUS_PENDING = "PENDING";
export const STATUS_PICKUP = "PICKUP"
export const ESTIMATION_STATUS = [
  STATUS_CANCEL,
  STATUS_PENDING,
  STATUS_CREATED,
  STATUS_PICKUP,
];